import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20and%20artistic%20illustration%20featuring%20an%20open%20manga%20book%20with%20glowing%20pages%20floating%20upward%2C%20surrounded%20by%20delicate%20cherry%20blossom%20petals%20and%20soft%20dreamy%20bokeh%20lights%2C%20warm%20coral%20and%20golden%20amber%20color%20palette%2C%20magical%20reading%20atmosphere%2C%20subtle%20gradient%20background%20with%20Japanese%20wave%20patterns%2C%20cinematic%20composition%2C%20ethereal%20and%20inviting%20mood&width=1600&height=700&seq=hero-bg-manga&orientation=landscape"
          alt="亲亲漫画 - 免费韩漫日漫国漫在线阅读"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/25"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-sparkling-line text-sm text-primary-300"></i>
              </div>
              <span className="text-xs md:text-sm text-background-50/90 font-medium">每日更新 · 海量漫画免费看</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
              亲亲漫画
              <span className="block text-xl md:text-2xl lg:text-3xl font-medium text-background-50/80 mt-2">
                韩漫日漫国漫 · 下拉式在线阅读
              </span>
            </h1>

            <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-lg leading-relaxed">
              提供亲亲漫画安卓APP与iOS手机版下载安装，免费看韩漫、日漫、国漫大全，支持下拉式在线阅读与离线缓存追更。每日更新热门漫画，畅享极致阅读体验。
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <a
                href="#download"
                className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-200 shadow-lg shadow-primary-500/25 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center inline-block mr-2 -mt-0.5 align-middle">
                  <i className="ri-download-line"></i>
                </div>
                免费下载APP
              </a>
              <Link
                to="/category/hanman"
                className="px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap"
              >
                开始阅读
                <div className="w-5 h-5 flex items-center justify-center inline-block ml-1 -mt-0.5 align-middle">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>

            <div className="flex items-center gap-5 mt-8 flex-wrap">
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                </div>
                <span className="text-xs text-background-50/70">完全免费</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                </div>
                <span className="text-xs text-background-50/70">每日更新</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                </div>
                <span className="text-xs text-background-50/70">高清画质</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                </div>
                <span className="text-xs text-background-50/70">离线缓存</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}